import { useTranslation } from 'react-i18next';

import type { PenRef, ProviderGroup } from '@/domain/providerConfig';
import { StoredExtrasList } from '@/routes/shared/ProviderConfig/StoredExtrasList';

import styles from './sections.module.scss';
import extra from './unknownExtra.module.scss';

/**
 * What the pens store that no field reads, by pen and full path, for every viewer.
 * Read-only: a save keeps these values as they are.
 */
export function UnknownExtraConfig({
    group,
    pens,
}: {
    group: ProviderGroup | null;
    pens: PenRef[];
}) {
    const { t } = useTranslation();
    const rows = (group?.rows ?? []).filter((row) => row.storedExtras.length > 0);
    if (rows.length === 0) return null;
    const nameOf = (cageId: number): string =>
        pens.find((pen) => pen.cageId === cageId)?.name ?? String(cageId);
    return (
        <div className={extra.unknownExtra}>
            <h4 className={styles.subheading}>{t('providerConfig.sections.unknownExtra')}</h4>
            <dl className={extra.extraList}>
                {rows.map((row) => (
                    <div key={row.rowId} className={extra.extraRow}>
                        <dt className={styles.penName}>{nameOf(row.cageId)}</dt>
                        <dd className={extra.extraValue}>
                            <StoredExtrasList entries={row.storedExtras} />
                        </dd>
                    </div>
                ))}
            </dl>
        </div>
    );
}
